import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/forwardhub/dashloadstatus'
import pathMap from 'src/paths/PathMap_ForwardHub'

class DashLoadStatusRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.DASH_LOAD_STATUS_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.DASH_LOAD_STATUS_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.DASH_LOAD_STATUS_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.DASH_LOAD_STATUS_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default DashLoadStatusRoute
